<script>
import BillingList from '@/components/widgets/billing-list.vue';
export default {
    name: 'UnpaidBillingList',
    components: {
        BillingList
    },
    data() {
        return {
            unpaidBillings: [],
            loading: true,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: '',
            billings: [],
        };
    },
    computed: {
        filtered() {
            let data = this.billings;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toLowerCase()
                        .includes(this.filter.toLowerCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows() {
            let data = this.billings;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
    },
    methods: { 
        async fetchUnpaidBillings() {
            this.$store
                .dispatch("billing/getUnpaidBillings", this.$store.state.data.selectedCampus.id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                    res.data.map((item) => {
                        item.visible = false;
                        item.showDetails = true;
                        item.itemVisible = false;
                    });
                    this.billings = res.data;
                })
                .catch((err) => {
                    this.showToast("Error deleting billing!", "error");
                });
        },
        setBilling(billing) {
            this.$emit('setBilling', billing);
        }
    }
};
</script>
<template>
    <b-modal
        id="unpaid-billing-modal"
        title="Unpaid Billing List"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="mb-3">
            <BillingList 
                type="unpaid"
                :list="billings"
                @set-billing="setBilling"
            />
        </div>
    </b-modal>
</template>